import { keepPreviousData } from '@tanstack/react-query';

import { MarketImagesResponse, MarketInfo } from '@playq/octopus2-markets';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const emptyArray: [] = [];

export const useRetrieveMarketsImage = (
  markets: MarketInfo[],
  options?: IUseQueryOptionsExtended<MarketImagesResponse | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(markets, () => services2.marketsService.retrieveMarketsImage(markets), {
    placeholderData: keepPreviousData,
    ...options,
  });

  return { ...res, images: res.data?.images || emptyArray };
};
